import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { catchError, Observable, switchMap, take, throwError } from 'rxjs';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return this.authService.getUserToken().pipe(
      take(1),
      switchMap((token) => {
        if (token) {
          const clonedRequest = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
          return next.handle(clonedRequest);
        }
        // Si no hay token, enviamos la solicitud tal cual o lanzamos un error
        return next.handle(req);
      }),
      catchError((error) => {
        console.error('Error en el interceptor:', error);
        return throwError(() => error);
      })
    );
  }
}
